import { orgActDetailsFun } from '../../../../api/orgActAPI';
import errorHandle from '../../../../utils/errorHandle';

export default async function fetchOrgActData(setLoading, setActivityData) {
    setLoading(true);
    const packId = window.location.pathname.split('/')[5];
    setLoading(true);
    try {
        //search result filter olage price range band data is reseting
        //search result api on change min and max price should go
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const result = await orgActDetailsFun(packId);
        setActivityData(result.data[0]);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}

export async function fetchOrgActDetails(setLoading, setPackData, tripId) {
    setLoading(true);
    try {
        //search result filter olage price range band data is reseting
        //search result api on change min and max price should go
        // for getDateDetailsFun you get an array of objects with tripDate id, start and end date of each
        const result = await orgActDetailsFun(tripId);
        setPackData(result.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
